import { Coordinates } from 'components/contexts/geolocation'
import { EVENTS_NEAR_YOU_DISTANCE } from 'constants/constant'
import React from 'react'
import { useScreenClass } from '~hooks'
import EventsList, { EventsProps } from '~shared/EventsList'
import UserLocationDropdown from '~shared/UserLocationDropdown'
import Grid from '~ui/Grid'
import Heading from '~ui/Heading'
import Typography from '~ui/Typography'

type NearEventsListProps = {
  location: Coordinates
  hideTevoLink?: boolean
  variables?: EventsProps['queryOptions']['variables']
  options?: EventsProps['options']
  filterData?: EventsProps['filterData']
}

const NearEventsListContainer: React.FC<NearEventsListProps> = ({
  location,
  hideTevoLink,
  filterData,
  variables,
  options,
}) => {
  const { isMobile } = useScreenClass()

  return (
    <EventsList
      hideTevoLink={hideTevoLink}
      title={
        <Grid
          gridAutoFlow={isMobile ? 'row' : 'column'}
          justifyContent="start"
          alignItems="center"
          gap={18}
        >
          <Heading Tag="h2" size="h4" fontWeight={500}>
            Events Near
          </Heading>
          <UserLocationDropdown
            locationTitleOptions={{
              size: 'h4',
              color: 'g-green-darker',
            }}
          />
        </Grid>
      }
      queryOptions={{
        variables: {
          ...variables,
          venueCoordinates: `${location?.latitude},${location?.longitude},${EVENTS_NEAR_YOU_DISTANCE}`,
          first: 5,
        },
        skip: !location,
      }}
      options={{
        venueName: true,
        ...options,
      }}
      itemListProps={{
        placeholderItemsCount: 3,
        noDataText: (
          <Typography.Text color="light-gray">
            No events near this location at this time. Try another location, or browse more events
            below.
          </Typography.Text>
        ),
      }}
      filterData={filterData}
    />
  )
}

export default NearEventsListContainer
